export type SupermarketTier = "premium" | "mid" | "value";

export interface SupermarketBrand {
  id: string;
  name: string;
  tier: SupermarketTier;
  searchTerms: string[];
}

export const SUPERMARKET_BRANDS: SupermarketBrand[] = [
  {
    id: "waitrose",
    name: "Waitrose",
    tier: "premium",
    searchTerms: ["Waitrose", "waitrose supermarket"],
  },
  {
    id: "ms-food",
    name: "M&S Food",
    tier: "premium",
    searchTerms: ["Marks and Spencer Food", "M&S Food", "Marks & Spencer"],
  },
  {
    id: "whole-foods",
    name: "Whole Foods",
    tier: "premium",
    searchTerms: ["Whole Foods Market", "Whole Foods"],
  },
  {
    id: "borough-market",
    name: "Borough Market",
    tier: "premium",
    searchTerms: ["Borough Market"],
  },
  {
    id: "tesco",
    name: "Tesco",
    tier: "mid",
    searchTerms: ["Tesco", "Tesco Express", "Tesco Metro"],
  },
  {
    id: "sainsburys",
    name: "Sainsbury's",
    tier: "mid",
    searchTerms: ["Sainsbury's", "Sainsburys", "Sainsbury's Local"],
  },
  {
    id: "coop",
    name: "Co-op",
    tier: "mid",
    searchTerms: ["Co-op Food", "Co-op", "Cooperative Food"],
  },
  {
    id: "lidl",
    name: "Lidl",
    tier: "value",
    searchTerms: ["Lidl"],
  },
  {
    id: "aldi",
    name: "Aldi",
    tier: "value",
    searchTerms: ["Aldi"],
  },
  {
    id: "morrisons",
    name: "Morrisons",
    tier: "value",
    searchTerms: ["Morrisons", "Morrisons Daily"],
  },
];

export const SUPERMARKETS_BY_ID = Object.fromEntries(
  SUPERMARKET_BRANDS.map((b) => [b.id, b])
) as Record<string, SupermarketBrand>;
